import React, { useEffect } from "react";
import "./Who_We_Are.css";
import Common_Title from "../../common/common-title/Common_Title";

const Who_We_Are = ({ whoweare }) => {
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();
  return (
    <section className="Who_We_Are">
      <div className="container">
        <Common_Title title="Who We Are " />
        <div className="Who_We_Are_content">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <div className="Who_We_Are_text_div">
                {/* <p className="Who_We_Are_text">
                   We are a dedicated career and parental counselling platform
                   committed to helping students discover the right career path
                  through scientifically designed assessments and professional
                  guidance. 
                  
                </p>
                <p className="Who_We_Are_text">
                  Our approach combines aptitude, personality, and interest
                  evaluations with expert counsellor insights to provide clear,
                  practical, and personalized recommendations.
                </p>  */}

                {whoweare?.slice(0, 2)?.map((item, index) => (
                  <p key={index} className="Who_We_Are_text">
                    <td> {htmlToReactParser.parse(item?.description)}</td>
                  </p>
                ))}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-12">
              <div className="Who_We_Are_img_div">
                <img
                  src="/assets/images/about-us/about-img.png"
                  alt="counselling-img"
                  className="Who_We_Are_img"
                />
              </div>
            </div>
          </div>
          <div className="colored_box_div">
            <div className="row">
              {/* <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
                <div className="mission_box col_box">
                  <h5 className="box_title">Our Mission</h5>
                  <p className="box_text">
                    To provide structured, data-driven career & parental
                    guidance that builds clarity, confidence, & long-term
                    direction for students.
                  </p>
                </div>
              </div>

              <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
                <div className="vision_box col_box">
                  <h5 className="box_title">Our Vision</h5>
                  <p className="box_text">
                    To become a trusted platform for career and parental
                    counselling, helping families make informed educational and
                    career decisions.
                  </p>
                </div>
              </div> */}

              {whoweare?.slice(2, 4)?.map((item, index) => (
                <div key={index} className="col-lg-6 col-md-6 col-sm-6 mb-3">
                  <div
                    className={`${
                      index === 0 ? "mission_box" : "vision_box"
                    } col_box`}
                  >
                    <h5 className="box_title">{item?.name}</h5>
                    <p className="box_text">
                      {item?.description?.replace(/<\/?[^>]+(>|$)/g, "")}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Who_We_Are;
